import { connect } from "react-redux";
import * as Redux from "redux";
import {
  getSchema,
  submitForm,
  flushReport,
  createReport
} from "../../actions";
import CreateReport from "./component";

const mapStateToProps = (state: any): any => {
  return {
    report: state.reportForm
  };
};

const mapDispatchToProps = (dispatch: Redux.Dispatch<any>): any => {
  return {
    ...Redux.bindActionCreators(
      { getSchema, submitForm, flushReport, createReport },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateReport);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/CreateReport/container.ts